import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

import Color from "@tool/color";
import "./scss/index.scss";
import CommonHead from "@/page/index/component/common-head";
import Title from "@/page/index/component/title";
import moRole, {
  changeRoleActive,
  changeRoleType,
  changeSubRole,
} from "../../store/role";
import CommonTab from "@/page/index/component/common-Tab";
import CommonTable from "@/page/index/component/common-table";
import RoleChart from "./component/role-chart";
import moIndex, { toggleTip } from "@/page/index/store";
import CommonTabList from "@/page/index/component/common-tab-list";
import { isEmpty, round } from "lodash";
import Empty from "@/component/empty";
import RoleChartTwo from "./component/role-chart-two";
import { exportExcelFile } from "@/tool";
import moUser from "@/store/user";

interface IProps {}
interface IState {}

// 人力需求
const RoleRecruitment = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    roleActive,
    roleType,
    subRoleList,
    categoryList,
    chartList1,
    chartList2,
    roleActive1,
  } = moRole;

  const topList = [
    "切换至表格，查看更多招聘薪酬分位值。",
    "统计说明：如果当前季度尚未过完，则当前季度数据的实际含义为近3个月的数据。",
  ];

  const getList = useMemo(() => {
    const list: any = [];
    categoryList?.forEach((res: any, r: any) => {
      if (res.name === roleActive) {
        list.push(categoryList[r]);
        if (r === categoryList.length - 1) {
          list.push(categoryList[0]);
        } else {
          list.push(categoryList[r + 1]);
        }
      }
    });
    return list;
  }, [roleActive, categoryList]);

  const getTwoList = (list: any) => {
    let result: any = ["全部"];
    list?.forEach((res: any) => {
      result.push(res.category_lv2);
    });
    return result;
  };

  const getChartResult = useMemo(() => {
    return [chartList1.data, chartList2.data];
  }, [chartList1, chartList2]);

  const getTableList = useMemo(() => {
    const list: any = [];
    let right: any = [];
    const cateList: any = [];
    if (
      !isEmpty(roleActive) &&
      !isEmpty(categoryList) &&
      !isEmpty(chartList1) &&
      !isEmpty(chartList2)
    ) {
      categoryList?.forEach((res: any, r: any) => {
        if (res.name === roleActive) {
          cateList[0] = categoryList[r].name;
          if (r === categoryList.length - 1) {
            cateList[1] = categoryList[0].name;
          } else {
            cateList[1] = categoryList[r + 1].name;
          }
        }
      });
      chartList1?.data?.forEach((res: any) => {
        list.push(cateList[0]);
      });
      chartList2?.data?.forEach((res: any) => {
        list.push(cateList[1]);
      });
      const allCategory = [...chartList1.data, ...chartList2.data];
      const result = allCategory?.map((res: any) => {
        const items = [
          res.date,
          res.amount,
          res.amount_change === 0 ? 0 : `${round(res.amount_change * 100, 1)}%`,
          res.salary,
          res.salary_change === 0 ? 0 : `${round(res.salary_change * 100, 1)}%`,
        ];
        return items;
      });
      right = result || [];
      right.unshift([
        "时间",
        "招聘量",
        "招聘量环比变化率",
        "招聘薪酬（元）",
        "招聘薪酬环比变化率",
      ]);
    }

    return { list, right };
  }, [roleActive, categoryList, chartList1, chartList2]);

  const exporttable = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    const list :any =[];
    const head :any =['职能',...getTableList.list];

    head.forEach((item:any,i:any)=>{
       const items:any =[item,...getTableList.right[i]];
       list.push(items);
    })
    const merge:any = [];
    exportExcelFile(list, merge, '人才需求构成');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="role-recruitment-warp">
      <section className="tops-title-warp" id="role">
        <Title title="人力指标" subtitle="职能招聘趋势" />
      </section>
      <section className="role-warp">
        <CommonHead
          title="人才需求构成"
          subTitle={moIndex.industry.name}
          type={roleType}
          bgColor={Color.primaryColor(0.1)}
          fontColor={Color.primary}
          contentList={topList}
          onChange={(val: string) => {
            changeRoleType(val);
          }}
        />
        <section className="role-tab">
          <CommonTabList
            list={categoryList}
            active={roleActive}
            active1={roleActive1}
            onChange={(val: string) => {
              changeRoleActive(val);
            }}
          />
        </section>
        {!isEmpty(categoryList) ? (
          <section className="role-content">
            {roleType === "chart" && (
              <section className="table">
                <section className="role-svg-warp">
                  {getList?.map((ele: any, e: any) => {
                    return (
                      <section className="items" key={e}>
                        <p className="svg-title">{ele.name}</p>
                        <section className="svg-content">
                          {getTwoList(ele.category_list)?.map(
                            (res: any, r: any) => {
                              return (
                                <span
                                  key={r}
                                  onClick={() => {
                                    changeSubRole(res, e);
                                  }}
                                  style={{
                                    backgroundColor:
                                      subRoleList[e] === res
                                        ? Color.primary
                                        : Color.white,
                                    borderColor:
                                      subRoleList[e] === res
                                        ? Color.primary
                                        : Color.ec,
                                    color:
                                      subRoleList[e] === res
                                        ? Color.fff
                                        : Color.blackColor(1),
                                  }}
                                >
                                  {res}
                                </span>
                              );
                            }
                          )}
                        </section>

                        {!isEmpty(getChartResult[e]) ? (
                          <RoleChart list={getChartResult[e]} index={e} />
                        ) : (
                          <Empty height="300px" margin="10px" />
                        )}
                      </section>
                    );
                  })}
                </section>
              </section>
            )}
            {roleType === 'table' && <section onClick={exporttable} className='export-table' style={{marginBottom:'10px',marginTop:0}}>导出excel</section>}
            {roleType === "table" && (
              <section className="role-content-table">
                <CommonTable
                  leftList={[[...["职能"], ...getTableList.list]]}
                  rightList={getTableList.right}
                />
              </section>
            )}
          </section>
        ) : (
          <Empty />
        )}
      </section>
    </section>
  );
};

export default observer(RoleRecruitment);
